$(document).ready( function() {

var $gallery = $('.collection-products');

  
$gallery.slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://img.icons8.com/cotton/36/000000/circled-chevron-left.png'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://img.icons8.com/cotton/36/000000/circled-chevron-right.png'>"
  
});  

});

 
$(document).ready( function() {
                //$("#gb-photo").change(function () {
                 $('body').on('change', '#gb-photo', function(){  
                    $(".main-uploaded-filed .holder").show();
                    $(".main-uploaded-filed .gb-textarea-product").show();
                    const file = this.files[0];
                    if (file) {
                        let reader = new FileReader();
                        reader.onload = function (event) {
                            $("#gb-imgPreview")
                              .attr("src", event.target.result);
                        };
                        reader.readAsDataURL(file);
                    }
                });
});
$(document).ready( function() {
   //  $(".gb-different-btn").click(function () {
   $('body').on('click', '.gb-different-btn', function(){
       $(".gb-file-filed").trigger('click');
     });
}); 



(function($){  
  
  var urlPathString = window.location.pathname;
  var template = urlPathString.split("/");
  var currentProductHandler = '';

  if ( template[1] == 'products' ) currentProductHandler = template[2];
  else if ( template[1] == 'collections' ) currentProductHandler = template[4];
  
  // set default on dropdown
  $('select#products-list > option').each(function() {
    if ( $(this).val() == currentProductHandler )
      $(this).prop('selected', 'selected');
  });
  
  // On dropdown change
  $("#products-list").on('change', function(e){
    e.preventDefault();

    var productHandle = $(this).val();
     $.getJSON('/products/'+ productHandle +'.js', function(product) {
       var get_link  = location.href;
       var get_half_link = get_link.split("/products/");
       location.replace(get_half_link[0]+'/products/'+ productHandle);
       //var final_link =  get_half_link[0]+'/products/'+ productHandle;
     });
      //$("#template-product").load(final_link+  "#template-product");
    
    
    //GB Comment STARTS
    /*$.getJSON('/products/'+ productHandle +'.js', function(product) {
      
      $("title").text( product.title );
      
      if ( currentProductHandler != 'replacement-bibboard-piece' ) {
        
        var id = product.variants[0].id;
      	$("input[name=id]").val( id );
        
      }
      else {
        
        var name = 'properties['+product.title+']';
        $('<input>').attr({
          type: 'hidden',
          id: 'replacement',
          name: 'properties[Product to Replace]',
          value: product.title,
        }).appendTo('form.product_form');
        
      }
      
      $("h1.product_name").text( product.title );
      
      if ( product.images.length > 1 ) {
      	
        $(".product-gallery__main .image__container img").attr('src', product.images[0]).attr('srcset', '');
        
        $.each( product.images, function(index, image){
        	
          $(".product-gallery__thumbnail img[data-index="+index+"]").attr('src', image);
          
        });
      }
      else {
      	
        $(".product-gallery__main .image__container img").attr('src', product.images[0]).attr('srcset', '');
      }
      
    });*/ //GB Comment ENDS
  });
  
  
  // On Gallery click
  var thumbnails = $('.collection-products  img');
  thumbnails.on('touchstart click', function(e){ 
  //$("#products-list").on('change', function(e){
    e.preventDefault();

    //var productHandle = $(this).val();
    var productHandle =$(this).data("handle")
    
    $("#products-list").val(productHandle); 
    
    $.getJSON('/products/'+ productHandle +'.js', function(product) {
      
      $("title").text( product.title );
      
      if ( currentProductHandler != 'replacement-bibboard-piece' ) {
        
        var id = product.variants[0].id;
      	$("input[name=id]").val( id );
        
      }
      else {
        
        var name = 'properties['+product.title+']';
        $('<input>').attr({
          type: 'hidden',
          id: 'replacement',
          name: 'properties[Product to Replace]',
          value: product.title,
        }).appendTo('form.product_form');
        
      }
      
      $("h1.product_name").text( product.title );
      
      if ( product.images.length > 1 ) {
      	
        $(".product-gallery__main .image__container img").attr('src', product.images[0]).attr('srcset', '');
        
        $.each( product.images, function(index, image){
        	
          $(".product-gallery__thumbnail img[data-index="+index+"]").attr('src', image);
          
        });
      }
      else {
      	
        $(".product-gallery__main .image__container img").attr('src', product.images[0]).attr('srcset', '');
      }
      
    });
  });  
  
  
  
  
  
  // on click gallery nav
  $('.product-gallery__thumbnail .gallery-cell img').on('click', function(e){
    e.preventDefault();
    $(".product-gallery__main .image__container img").attr('src', $(this).attr('src')).attr('srcset', '');
    return false;
  });

   $('button.product-gallery__thumbnail').on('click touchstart', function(e){
    e.preventDefault();
      //$('.single-option-selector  option[value="3D Rubeez Be Happy Rainbow"]').prop('selected', 'selected');
      //$('.single-option-selector option[value="3D Rubeez Be Happy Rainbow"]').trigger("change");
      //$('.selector-wrapper .single-option-selector').val('3D Rubeez Be Happy Rainbow').prop('selected', 'selected').change();
      //var getfirst = $(this).attr('data-title');

     
     /* var getfirst = $(this).attr('data-index');
       console.log(getfirst);
      var get_sub_val = parseInt(getfirst) - 1;*/
     var getfirst = $(this).attr('data-variant-id-img');
       console.log(getfirst);
      var get_sub_val = getfirst;

     
     /* var get_index =  $(".selector-wrapper .single-option-selector option:eq('"+get_sub_val+"')").prop('selected', 'selected');

      
      var get_title = get_index.html();
       console.log(get_title);   */
      //var get_vall = "3D Rubeez Be Happy Rainbow";
     /* var get_id = $('.variant-selection__variants option[name="'+get_title+'"]').val();
      console.log(get_id);*/
      /*$("variant-selection.variant-selection").attr("variant", get_id);*/
      //console.log(gbget);

    // $(".gb-variant-select label").prop("data-index", getfirst).addClass("dcdcd");

   /* $(".gb-variant-select label").filter(function() {
      $(this).toggle($(this).attr("data-index", getfirst).addClass("dcdcd"));
    });*/
    /* $('.gb-variant-select label').filter(function() {
        // $(this).toggleClass("dcdcd");
        $(this).toggleClass($(this).find('.gb-variant-select label[data-index="'+getfirst+'"]').addClass("dcdcd"));
     });*/
 
     var get_id = $(this).closest('.gb-main-div-product').find('.gb-get-id span[data-variant-id-img="'+get_sub_val+'"]').text();
    //var get_id = $(this).closest('.gb-main-div-product').find('.gb-get-id span[data-index="'+get_sub_val+'"]').text();
    
     $('[name="id"]').val(get_id);
     //var get_text = $(this).closest('.gb-main-div-product').find('.gb-variant-select label[data-index="'+get_sub_val+'"]').text();
    
     var get_text = $(this).closest('.gb-main-div-product').find('.gb-variant-select label[data-variant-id-img="'+get_sub_val+'"]').text();
    
     $('.gb-add-text-variant').text(get_text);

    $('.variant-picker__option-info span').text(get_text);
     
    
   });


   $('.product-gallery__media').on('click touchstart', function(e){
   
      setTimeout(function () {
          var getfirst = $('.product-gallery__media.is-selected').attr('data-variant-id-img');
          console.log(getfirst);
          var get_sub_val = getfirst;
 //   alert(get_sub_val);
      //$('.single-option-selector  option[value="3D Rubeez Be Happy Rainbow"]').prop('selected', 'selected');
      //$('.single-option-selector option[value="3D Rubeez Be Happy Rainbow"]').trigger("change");
      //$('.selector-wrapper .single-option-selector').val('3D Rubeez Be Happy Rainbow').prop('selected', 'selected').change();
      //var getfirst = $(this).attr('data-title');

     
     /* var getfirst = $(this).attr('data-index');
       console.log(getfirst);
      var get_sub_val = parseInt(getfirst) - 1;*/
     /*var getfirst = $(this).attr('data-variant-id-img');
       console.log(getfirst);
      var get_sub_val = getfirst*/

     
     /* var get_index =  $(".selector-wrapper .single-option-selector option:eq('"+get_sub_val+"')").prop('selected', 'selected');

      
      var get_title = get_index.html();
       console.log(get_title);   */
      //var get_vall = "3D Rubeez Be Happy Rainbow";
     /* var get_id = $('.variant-selection__variants option[name="'+get_title+'"]').val();
      console.log(get_id);*/
      /*$("variant-selection.variant-selection").attr("variant", get_id);*/
      //console.log(gbget);

    // $(".gb-variant-select label").prop("data-index", getfirst).addClass("dcdcd");

   /* $(".gb-variant-select label").filter(function() {
      $(this).toggle($(this).attr("data-index", getfirst).addClass("dcdcd"));
    });*/
    /* $('.gb-variant-select label').filter(function() {
        // $(this).toggleClass("dcdcd");
        $(this).toggleClass($(this).find('.gb-variant-select label[data-index="'+getfirst+'"]').addClass("dcdcd"));
     });*/
 
     var get_id = $('.gb-main-div-product').find('.gb-get-id span[data-variant-id-img="'+get_sub_val+'"]').text();
    //var get_id = $(this).closest('.gb-main-div-product').find('.gb-get-id span[data-index="'+get_sub_val+'"]').text();
   
     $('[name="id"]').val(get_id);
     //var get_text = $(this).closest('.gb-main-div-product').find('.gb-variant-select label[data-index="'+get_sub_val+'"]').text();
    
     var get_text = $('.gb-main-div-product').find('.gb-variant-select label[data-variant-id-img="'+get_sub_val+'"]').text();
    
     $('.gb-add-text-variant').text(get_text);

    $('.variant-picker__option-info span').text(get_text);
     
       }, 2000);  
   });


  $('.gb-dots').on('click touchstart', function(e){
  
      setTimeout(function () {
          var getfirst = $('.product-gallery__media.is-selected').attr('data-variant-id-img');
          console.log(getfirst);
          var get_sub_val = getfirst;
 //   alert(get_sub_val);
      //$('.single-option-selector  option[value="3D Rubeez Be Happy Rainbow"]').prop('selected', 'selected');
      //$('.single-option-selector option[value="3D Rubeez Be Happy Rainbow"]').trigger("change");
      //$('.selector-wrapper .single-option-selector').val('3D Rubeez Be Happy Rainbow').prop('selected', 'selected').change();
      //var getfirst = $(this).attr('data-title');

     
     /* var getfirst = $(this).attr('data-index');
       console.log(getfirst);
      var get_sub_val = parseInt(getfirst) - 1;*/
     /*var getfirst = $(this).attr('data-variant-id-img');
       console.log(getfirst);
      var get_sub_val = getfirst*/

     
     /* var get_index =  $(".selector-wrapper .single-option-selector option:eq('"+get_sub_val+"')").prop('selected', 'selected');

      
      var get_title = get_index.html();
       console.log(get_title);   */
      //var get_vall = "3D Rubeez Be Happy Rainbow";
     /* var get_id = $('.variant-selection__variants option[name="'+get_title+'"]').val();
      console.log(get_id);*/
      /*$("variant-selection.variant-selection").attr("variant", get_id);*/
      //console.log(gbget);

    // $(".gb-variant-select label").prop("data-index", getfirst).addClass("dcdcd");

   /* $(".gb-variant-select label").filter(function() {
      $(this).toggle($(this).attr("data-index", getfirst).addClass("dcdcd"));
    });*/
    /* $('.gb-variant-select label').filter(function() {
        // $(this).toggleClass("dcdcd");
        $(this).toggleClass($(this).find('.gb-variant-select label[data-index="'+getfirst+'"]').addClass("dcdcd"));
     });*/
 
     var get_id = $('.gb-main-div-product').find('.gb-get-id span[data-variant-id-img="'+get_sub_val+'"]').text();
    //var get_id = $(this).closest('.gb-main-div-product').find('.gb-get-id span[data-index="'+get_sub_val+'"]').text();
   
     $('[name="id"]').val(get_id);
     //var get_text = $(this).closest('.gb-main-div-product').find('.gb-variant-select label[data-index="'+get_sub_val+'"]').text();
    
     var get_text = $('.gb-main-div-product').find('.gb-variant-select label[data-variant-id-img="'+get_sub_val+'"]').text();
    
     $('.gb-add-text-variant').text(get_text);

    $('.variant-picker__option-info span').text(get_text);
     
       }, 2000);  
   });
    //$('button.flickity-button').on('click', function(){
    //$('body').on('click', '.product-gallery__main', function(){  
    //e.preventDefault();
      //var getfirst = $(this).find('.product-gallery__image.is-selected img').attr('data-index');
      //alert('getfirst'); 
      /*var get_sub_val = parseInt(getfirst);
      var get_index =  $(".selector-wrapper .single-option-selector option:eq('"+get_sub_val+"')").prop('selected', 'selected');
      
      var get_title = get_index.html();
         
      //var get_vall = "3D Rubeez Be Happy Rainbow";
      var get_id = $(".variant-selection__variants option[name='"+get_title+"']").val();
      $("variant-selection.variant-selection").attr("variant", get_id);*/
      //console.log(gbget);
   //});
 
  // on click business nav
  var business = $('.vertical-menu .dropdown_link--vertical');
  
  if ( business ) {
  	$( business ).on('click', function(e){
      e.preventDefault();
      
      return false;
    });
  }  

 /*   var currentURL = window.location.href;
    var get_url_cudtom = currentURL.split("build-your-own#");
    if(get_url_cudtom[1] == 'contact_form') {
      $(".sucessfull-message-custom").show();
    }*/
  
})(jQuery);

// Continue Shopping button for Upnova cart drawer
(function () {
  var BUTTON_ID = 'gb-continue-shopping-btn';

  function queryInShadows(root, selector) {
    var found = root.querySelector(selector);
    if (found) return found;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        found = queryInShadows(all[i].shadowRoot, selector);
        if (found) return found;
      }
    }
    return null;
  }

  function closeUpnovaCart() {
    var widget = document.getElementById('upezCart');
    if (!widget || !widget.shadowRoot) return;
    // Find Upnova's own X close button by its SVG path (the cross/close icon)
    var path = widget.shadowRoot.querySelector('path[d*="7.5 7.5L16.5 16.5"]');
    var closeBtn = path && path.closest('button');
    if (closeBtn) closeBtn.click();
  }

  function injectContinueShopping() {
    if (queryInShadows(document, '#' + BUTTON_ID)) return;
    var checkoutBtn = queryInShadows(document, 'button[name="checkout"]');
    if (!checkoutBtn) return;
    var buttonWrapper = checkoutBtn.parentElement;
    if (!buttonWrapper || !buttonWrapper.parentNode) return;
    var btn = document.createElement('button');
    btn.id = BUTTON_ID;
    btn.type = 'button';
    btn.textContent = 'Continue Shopping';
    btn.style.cssText = 'display:block;width:100%;height:56px;padding:0 18px;margin-bottom:8px;background:transparent;color:var(--brand_color,#333);border:1px solid var(--brand_color,#333);border-radius:9999px;font-size:16px;font-family:inherit;letter-spacing:0.5px;cursor:pointer;text-align:center;box-sizing:border-box';
    btn.addEventListener('click', closeUpnovaCart);
    buttonWrapper.parentNode.insertBefore(btn, buttonWrapper);
  }


  var pollInterval = setInterval(function () {
    if (queryInShadows(document, 'button[name="checkout"]')) {
      injectContinueShopping();
    }
  }, 400);

  setTimeout(function () { clearInterval(pollInterval); }, 120000);
})();